import * as jose from 'jose';
import type { JWTPayload } from 'jose';

type CasumoJWT = JWTPayload & {
    player_id?: string;
    authorization?: {
        casumo_session?: string;
        authorization_error?: string[];
    };
    is_fully_registered?: boolean;
};

export type DecodedAccessToken = ReturnType<typeof decodeAccessToken>;

export const decodeAccessToken = (accessToken?: string) => {
    if (!accessToken) {
        return;
    }
    const decoded: CasumoJWT = jose.decodeJwt(accessToken);
    return {
        playerId: decoded.player_id,
        sessionId: decoded.authorization?.casumo_session,
        authError: decoded.authorization?.authorization_error,
        isRegistered: !!decoded.is_fully_registered
    };
};
